// @flow
import { FormControlLabel, Switch as MuSwitch } from '@mui/material';
import { Controller } from 'react-hook-form';
import type { switchType } from '@shared/model/components';

function Switch({
	label,
	negativeLabel = label,
	name,
	control,
	errors,
	defaultValue = false,
	color,
	size,
	...switchProps
}: switchType): React$Node {
	return (
		<Controller
			name={name}
			defaultValue={defaultValue}
			control={control}
			render={({ field }) =>
				label ? (
					<FormControlLabel
						{...switchProps}
						control={<MuSwitch
							color={color}
							size={size}
							checked={field.value}
							{...field} />}
						label={field.value ? label : negativeLabel}
					/>
				) : (
					<MuSwitch
						{...switchProps}
						color={color}
						size={size}
						checked={field.value}
						{...field}
					/>
				)
			}
		/>
	);
}

export default Switch;
